<template>
  <div class="wrapperddiv">
    <el-card class="box-card">
		<el-row  type="flex" justify="end" >
			<el-button-group>
			<el-button type="danger" @click="delSelectDialogVisible=true">区间批量删除</el-button>
			</el-button-group>
			<el-upload
			    class="upload-demo"
			    action=""
			    :on-change="handleChange"
			    :show-file-list="false"
			    :auto-upload="false">
			    <el-button  type="primary" >导入excel文件</el-button>
			  </el-upload>
			<el-button-group>
		<!-- 	<el-button type="primary" @click="exportTableData">导出表格数据</el-button>
			<el-button type="primary" @click="exportSelectData">导出选中的行数据</el-button> -->
			</el-button-group>
			</el-row>
			<el-divider></el-divider>
		<el-row :gutter="20">
			<el-col :span="2">
				<el-button type="text" style="color: black;">网络类别:</el-button>
			</el-col>
				<el-col :span="6">
					<el-select v-model="queryInfo.category" filterable placeholder="请选择" clearable>
					  <el-option
					    v-for="item in categoryList"
					    :key="item.category"
					    :label="item.category"
					    :value="item.category">
					  </el-option>
					</el-select>
					</el-col>
					<el-col :span="2">
						<el-button type="text" style="color: black;">重量:</el-button>
					</el-col>
						<el-col :span="6">
							<el-select v-model="queryInfo.weight" filterable placeholder="请选择" clearable>
							  <el-option
							    v-for="item in weightList"
							    :key="item.weight"
							    :label="item.weight"
							    :value="item.weight">
							  </el-option>
							</el-select>
							</el-col>
							<el-col :span="2">
								<el-button type="primary" @click="this.initListFn">查询</el-button>
							</el-col>
								
		</el-row>
		
			
	
		
	<el-divider></el-divider>
      <div slot="header" class="clearfix header-box">
        <span>国际快递数据库</span>
      </div>
      <!-- 表格区域 -->
      <el-table
	  v-loading="loading"
	  element-loading-text="拼命加载中"
	  element-loading-spinner="el-icon-loading"
	  element-loading-background="rgba(0, 0, 0, 0.8)"
	  style="width: 100%" 
	  :data="dataList" 
	  border 
	  stripe 
	  ref="tableDataRef"
	  row-key="id"
	 :header-cell-style="{ 'background':'#E9E9E9','color':'#000000' }"
	  @selection-change="handleSelectionChange">
	  <el-table-column
	    type="selection"
	  	  :reserve-selection="true"
	        width="55">
	      </el-table-column>
        <el-table-column
          label="序号"
          type="index"
        >
		</el-table-column>
		<el-table-column label="ID" prop="id"></el-table-column>
		<el-table-column label="网络类别" prop="category" width="150px"></el-table-column>
		<el-table-column label="重量" prop="weight"></el-table-column>
		<el-table-column label="燃油费" prop="fuel"></el-table-column>
		<el-table-column label="T1" prop="T1" ></el-table-column>
		<el-table-column label="T2" prop="T2" ></el-table-column>
		<el-table-column label="1" prop="one" ></el-table-column>
		<el-table-column label="2" prop="two" ></el-table-column>
		<el-table-column label="A" prop="a" ></el-table-column>
		<el-table-column label="B" prop="b" ></el-table-column>
		<el-table-column label="D" prop="d" ></el-table-column>
		<el-table-column label="E" prop="e" ></el-table-column>
		<el-table-column label="F" prop="f" ></el-table-column>
		<el-table-column label="G" prop="g" ></el-table-column>
		<el-table-column label="H" prop="h" ></el-table-column>
		<el-table-column label="K" prop="k" ></el-table-column>
		<el-table-column label="M" prop="m" ></el-table-column>
		<el-table-column label="N" prop="n" ></el-table-column>
		<el-table-column label="O" prop="o" ></el-table-column>
		<el-table-column label="P" prop="p" ></el-table-column>
		<el-table-column label="Q" prop="q" ></el-table-column>
		<el-table-column label="R" prop="r" ></el-table-column>
		<el-table-column label="S" prop="s" ></el-table-column>
		<el-table-column label="T" prop="t" ></el-table-column>
		<el-table-column label="U" prop="u" ></el-table-column>
		<el-table-column label="V" prop="v" ></el-table-column>
		<el-table-column label="X" prop="x" ></el-table-column>
		<el-table-column label="Y" prop="y" ></el-table-column>
		<el-table-column label="Z" prop="z" ></el-table-column>
		<el-table-column label="总费用" prop="total_cost" width="150px"></el-table-column>
		<el-table-column label="折扣" prop="discount" width="150px"></el-table-column>
		<el-table-column label="有效期" prop="timelimit" width="150px"></el-table-column>
		<el-table-column label="按体积" prop="by_volume" width="150px"></el-table-column>
		<el-table-column label="备注" prop="remark" width="150px" :show-overflow-tooltip="true"></el-table-column>
		<el-table-column label="更新日期" prop="update_time" width="150px"></el-table-column>
        <el-table-column label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
				<el-button type="primary" size="mini" @click="updateFn(scope.row.id)">修改</el-button>
                <el-button type="danger" size="mini" @click="removeFn(scope.row.id)">删除</el-button>
            </template>
        </el-table-column>
      </el-table>
	  <!-- 分页区域 -->
	  			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
	  				:current-page="queryInfo.pagenum" :page-sizes="[10,50,100,200]"
	  				:page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
	  			</el-pagination>
    </el-card>
	
	<el-dialog :lock-scroll="false" title="修改" :visible.sync="editDialogVisible" width="90%"
		@close="editDialogClosed" :close-on-click-modal="false" top="5vh">
		<el-form ref="editFormRef" :model="editForm" label-width="100px">
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="网络类别" prop="category">
						<el-input v-model="editForm.category"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="重量" prop="weight">
						<el-input v-model="editForm.weight"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="燃油费" prop="fuel">
						<el-input v-model="editForm.fuel"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="T1" prop="T1">
						<el-input v-model="editForm['T1']"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
	
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="T2" prop="T2">
						<el-input v-model="editForm['T2']"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="1" prop="one">
						<el-input v-model="editForm['one']"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="2" prop="two">
						<el-input v-model="editForm['two']"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="A" prop="a">
						<el-input v-model="editForm['a']"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
	
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="B" prop="b">
						<el-input v-model="editForm['b']"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="D" prop="d">
						<el-input v-model="editForm['d']"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="E" prop="e">
						<el-input v-model="editForm['e']"></el-input>
					</el-form-item>
				</el-col>
	
				<el-col :span="6">
					<el-form-item label="F" prop="f">
						<el-input v-model="editForm['f']"></el-input>
					</el-form-item>
				</el-col>
			</el-row>
	
	<el-row :gutter="20">
		<el-col :span="6">
			<el-form-item label="G" prop="g">
				<el-input v-model="editForm['g']"></el-input>
			</el-form-item>
		</el-col>
		<el-col :span="6">
			<el-form-item label="H" prop="h">
				<el-input v-model="editForm['h']"></el-input>
			</el-form-item>
		</el-col>
		<el-col :span="6">
			<el-form-item label="K" prop="k">
				<el-input v-model="editForm['k']"></el-input>
			</el-form-item>
		</el-col>
		
		<el-col :span="6">
			<el-form-item label="M" prop="m">
				<el-input v-model="editForm['m']"></el-input>
			</el-form-item>
		</el-col>
	</el-row>
		
	<el-row :gutter="20">
		<el-col :span="6">
			<el-form-item label="N" prop="n">
				<el-input v-model="editForm['n']"></el-input>
			</el-form-item>
		</el-col>
		<el-col :span="6">
			<el-form-item label="O" prop="o">
				<el-input v-model="editForm['o']"></el-input>
			</el-form-item>
		</el-col>
		<el-col :span="6">
			<el-form-item label="P" prop="p">
				<el-input v-model="editForm['p']"></el-input>
			</el-form-item>
		</el-col>
		
		<el-col :span="6">
			<el-form-item label="Q" prop="q">
				<el-input v-model="editForm['q']"></el-input>
			</el-form-item>
		</el-col>
	</el-row>
		
		<el-row :gutter="20">
			<el-col :span="6">
				<el-form-item label="R" prop="r">
					<el-input v-model="editForm['r']"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="S" prop="s">
					<el-input v-model="editForm['s']"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item label="T" prop="t">
					<el-input v-model="editForm['t']"></el-input>
				</el-form-item>
			</el-col>
			
			<el-col :span="6">
				<el-form-item label="U" prop="u">
					<el-input v-model="editForm['u']"></el-input>
				</el-form-item>
			</el-col>
		</el-row>
	
	<el-row :gutter="20">
		<el-col :span="6">
			<el-form-item label="V" prop="v">
				<el-input v-model="editForm['v']"></el-input>
			</el-form-item>
		</el-col>
		<el-col :span="6">
			<el-form-item label="X" prop="x">
				<el-input v-model="editForm['x']"></el-input>
			</el-form-item>
		</el-col>
		<el-col :span="6">
			<el-form-item label="Y" prop="y">
				<el-input v-model="editForm['y']"></el-input>
			</el-form-item>
		</el-col>
		
		<el-col :span="6">
			<el-form-item label="Z" prop="z">
				<el-input v-model="editForm['z']"></el-input>
			</el-form-item>
		</el-col>
	</el-row>
			<el-row :gutter="20">
				<el-col :span="6">
					<el-form-item label="总费用" prop="total_cost">
						<el-input v-model="editForm.total_cost"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="折扣" prop="discount">
						<el-input v-model="editForm.discount"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="有效期" prop="timelimit">
						<el-input v-model="editForm.timelimit"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="6">
					<el-form-item label="按体积" prop="by_volume">
						<el-input v-model="editForm.by_volume"></el-input>
					</el-form-item>
				</el-col>
				
	
			</el-row>
	
	
	<el-row :gutter="20">
	<el-col :span="6">
		<el-form-item label="备注" prop="remark">
			<el-input v-model="editForm.remark" type="textarea"></el-input>
		</el-form-item>
	</el-col>
	</el-row>
	
	
	
	
	
	
		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="editDialogVisible = false">取消</el-button>
			<el-button type="primary" @click="editConfirm">确定修改</el-button>
		</span>
	</el-dialog>
	
	
	
	
	
	
	<el-dialog
	:lock-scroll="false" 
	title="区间批量删除" 
	:visible.sync="delSelectDialogVisible" 
	width="50%"
	@close="delSelectDialogClosed" 
	:close-on-click-modal="false">
		<el-form 
		ref="delSelectFormRef" 
		:model="delSelectForm" 
		label-width="100px">
		<el-row :gutter="20">
			<el-col :span="2">
				<el-button type="text" style="color: black;">选择ID区间:</el-button>
			</el-col>
			<el-col :span="9">
				<el-form-item  prop="start">
					<el-input v-model="delSelectForm.start"  type="number"></el-input>
				</el-form-item>
			</el-col>
			<el-col :span="1">
				<el-button type="text" style="color: black;">到</el-button>
			</el-col>
			<el-col :span="9"  style="margin-left: -95px;">
				<el-form-item  prop="end">
					<el-input v-model="delSelectForm.end" type="number" ></el-input>
				</el-form-item>
			</el-col>
		</el-row>
		</el-form>
		<span slot="footer" class="dialog-footer">
				<el-button @click="delSelectDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="delSelectConfirm">确 定</el-button>
			</span>
		</el-dialog>
	
  </div>
</template>

<script>
//表格导入依赖
import XLSX from 'xlsx'
import moment from 'moment';
export default {
  data () {
    return {
		categoryList:[],
		weightList:[],
		loading:false,
		fileContent: '',
		file: '',
		data: '',
		//选中行导出的值
		selectionList:[],
		multipleSelection:[],
		queryInfo: {
			category:'',
			weight:'',
			//当前的页数
			pagenum: 1,
			//当前每页显示多少条数据
			pagesize: 10,
		},
		total: 0,
      dataList: [], // 数据列表
	  //区间批量删除
	  delSelectDialogVisible:false,
	  delSelectForm:{
	  	start:'',
	  	end:''
	  },
	  editDialogVisible: false,
	  editForm: {}
    }
  },
  
  created () {
    this.initListFn()
  },
  methods: {
	  //导出表格数据
	   exportTableData () {
	        // 获取dom元素（2种方式）
	        let table = this.$refs.tableDataRef.$el
	        let sheet = XLSX.utils.table_to_sheet(table)
	        let book = XLSX.utils.book_new()
	        XLSX.utils.book_append_sheet(book, sheet, "sheet1")
	        XLSX.writeFile(book, `lclFreight.xls`)
	      },
	  	//导出行数据
	  	 //监听复选框选中的值
	  	 handleSelectionChange(val){
	  		            this.selectionList = val
						//console.log(this.selectionList)
	  	 				let arryVal = val.map((item)=>{
	  	 					return item.id
	  	 				})
	  	 				 this.multipleSelection = arryVal;
						 //console.log(this.multipleSelection)
	  	 			},
	  	    exportSelectData () {
	  	      // 对选择的表格数据处理：添加标题
	  	      let arr = this.selectionList.map(item => {
	  	        return {
	  				   ID:item.id,
					   起运港:item.pol,
						 目的港:item.pod,
						 国家:item.country,
					    ['体积价(T0)']: item.freight_cmb_T0,
						['重量价(T0)']:item.freight_ton_T0,
						['体积价(T1)']:item.freight_cmb_T1,
						['重量价(T1)']:item.freight_ton_T1,
						['体积价(T2)']:item.freight_cmb_T2,
						['重量价(T2)']:item.freight_ton_T2,
						截单日:item.close_date,
						开航日:item.etd,
						 中转港:item.via,
						 预计航程:item['t_t'],
						 生效日:item.valid_fm,
						 失效日:item.valid_to,
                         备注:item.remark,	   
	  	        }
	  	      })
	  	      // 将json数据变为sheet数据
	  	      // json_to_sheet: 将一个由对象组成的数组转成sheet；
	  	      let sheet = XLSX.utils.json_to_sheet(arr)
	  	      // 新建表格
	  	      let book = XLSX.utils.book_new()
	  	      // 在表格中插入一个sheet
	  	      XLSX.utils.book_append_sheet(book, sheet, "sheet1")
	  	      // 通过xlsx的writeFile方法将文件写入
	  	      XLSX.writeFile(book, `lclFreight.xls`)
	  	    },
	 
	  
	  //导入功能*****************************************************
	  			// 核心部分代码(handleChange 和 importfile)
	  			handleChange (file, fileList) {
	  			  this.fileContent = file.raw
	  			  const fileName = file.name
	  			  const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
				  if(file.size / 1024 /1024 > 2){
				  return	this.$message({
				  		type: 'warning',
				  		message: '该文件大小不能超过2MB,请检查ID是否异常溢出！'
				  	})
				  }
				  
	  			    if (this.fileContent) {
	  			      if (fileType === 'xlsx' || fileType === 'xls') {
	  			        this.importfile(this.fileContent)
	  			      } else {
	  			        this.$message({
	  			          type: 'warning',
	  			          message: '附件格式错误，请重新上传！'
	  			        })
	  			      }
	  			    } else {
	  			      this.$message({
	  			        type: 'warning',
	  			        message: '请上传附件！'
	  			      })
	  			    }
	  			  },
	  			 importfile (obj) {
	  			   const reader = new FileReader()
	  			   const _this = this
	  			   reader.readAsArrayBuffer(obj)
	  			   reader.onload = async function(){
	  			     const buffer = reader.result
	  			     const bytes = new Uint8Array(buffer)
	  			     const length = bytes.byteLength
	  			     let binary = ''
	  			     for (let i = 0; i < length; i++) {
	  			       binary += String.fromCharCode(bytes[i])
	  			     }
	  			      const XLSX = require('xlsx')
	  			      const wb = XLSX.read(binary, {
	  			        type: 'binary',
						cellDates: true
	  			      })
	  			      const outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]])
	  			      this.data = [...outdata]
					  console.log(this.data)
	  			      const arr = []
	  			      this.data.map (v => {
	  			        const obj ={}
	  			          obj.id = v['ID']
						  obj.category = v['网络类别'],
						  obj.weight = v['重量']
						  obj.fuel = v['燃油费']
						  obj.T1 = v['T1']
						  obj.T2 = v['T2']
						  obj.one = v['1']
						  obj.two = v['2']
						  obj.a = v['A']
						  obj.b = v['B']
						  obj.d = v['D']
						  obj.e = v['E']
						  obj.f = v['F']
						  obj.g = v['G']
						  obj.h = v['H']
						  obj.k = v['K']
						  obj.m = v['M']
						  obj.n = v['N']
						  obj.o = v['O']
						  obj.p = v['P']
						  obj.q = v['Q']
						  obj.r = v['R']
						  obj.s = v['S']
						  obj.t = v['T']
						  obj.u = v['U']
						  obj.v = v['V']
						  obj.x = v['X']
						  obj.y = v['Y']
						  obj.z = v['Z']
						  obj.total_cost = v['总费用']
						  obj.discount = v['折扣']
						  obj.timelimit = v['有效期']
						  obj.by_volume = v['按体积']
						  obj.remark = v['备注']
						  obj.update_time =  v['更新日期'] = moment(v['更新日期']).format('YYYY-MM-DD')
	  					//console.log(obj)
	               arr.push(obj)
	  			      })
					  console.log(arr)
	  				 // //后端请求数据
	  				 // //这里不能用this，用_this
					 //数据格式化数组对象转成(),(),()
					 //方法一，以""规则分割
					 let str = arr.reduce((total,item,index)=>{
						 //累加三个逗号
					     if(index!=0){total+=','}
					     total+='("'+ encodeURIComponent(Object.values(item).join('","'))  +'")'
					     return total
					 },"")
					   let datainfo={
						   infoString:decodeURIComponent(str)
					   }
					 
					 const {data: res} = await _this.$http.addMoreExpressData({data:datainfo})				 
					 if (res.status !== 0) {
					 	return _this.$message.error(res.message)
					 }
					   _this.$message.success('导入成功！')
					setTimeout(() => {
						window.location.reload()
					     }, 500);
	  			    }
	  			  },
	  // 获取列表；获取下拉数据也获取所有列表数据
	  async initListFn () {
		  this.loading = true
	    const {data:res} = await this.$http.getByExpressData({params:this.queryInfo})
			if (res.status !==0){
			 return this.$message.error('获取数据失败!')
			}
	      this.dataList = res.data
		  this.total = res.total
		  this.loading = false
		  this.categoryList = res.category
		  this.weightList = res.weight
	  },
	  //监听pagesize改变的事件
	  handleSizeChange(newSize) {
	  	this.queryInfo.pagesize = newSize
	  	this.initListFn()
	  },
	  //监听页面值改变的事件
	  handleCurrentChange(newPage) {
	  	this.queryInfo.pagenum = newPage
	  	this.initListFn()
	  },
    // 删除
    async removeFn (id) {
		const confirmResult = await this.$confirm('此操作将删除这条数据是否继续?', '提示', {
		  confirmButtonText: '确定',
		  cancelButtonText: '取消',
		  type: 'warning',
		   lockScroll:false
		}).catch(err => err)
		if (confirmResult !== 'confirm'){
			return this.$message.info('已取消删除')
		}
		const { data: res } = await this.$http.delExpressData(id)
		if (res.status!== 0) return this.$message.error('删除失败！')
		this.$message.success('删除成功！')
		// 重新请求列表数据
		this.initListFn()
		
    },
	
	
	//区间删除
	async delSelectConfirm(){
		if (this.delSelectForm.start == '' && this.delSelectForm.end == '') {
			return this.$message.warning('请填写ID！')
		}
		const confirmResult = await this.$confirm('注意！此操作将批量删除, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
			lockScroll:false
		}).catch(err => err)
		//如果确认删除，则返回值为字符串 confirm
		console.log(confirmResult)
		if (confirmResult !== 'confirm') {
			return this.$message.info('已取消删除')
		}
		let idString = `${this.delSelectForm.start},${this.delSelectForm.end}`
		const {
			data: res
		} = await this.$http.delBatchExpressData({
			id: idString
		})
		if (res.status !== 0) {
			return this.$message.error('批量删除失败!')
		}
		this.$message.success('批量删除成功!')
		this.initListFn()
		this.delSelectDialogVisible = false
		},
		delSelectDialogClosed(){
			this.$refs.delSelectFormRef.resetFields()
		},
		async updateFn(id) {
			const {
				data: res
			} = await this.$http.byIdExpressData(id)
			if (res.status !== 0) {
				return this.$message.error('获取数据失败!')
			}
			this.editForm = res.data
			this.editDialogVisible = true
		},
		async editConfirm() {
			const {
				data: res
			} = await this.$http.editExpressData(this.editForm)
			if (res.status !== 0) {
				return this.$message.error('修改失败!')
			}
			this.$message.success('修改成功!')
			this.editDialogVisible = false
			this.initListFn()
		},
		editDialogClosed() {
			this.$refs.editFormRef.resetFields()
		}

  }
}
</script>

<style lang="less" scoped>
.header-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media screen and (min-width: 1280px) {
		.wrapperddiv{
			height: 100vh;
			width: 100%;
			display:inline-block;
		} 
	}
	
	//手机端
	@media screen and (max-width: 1280px) {
		.wrapperddiv{
			height: 100%;
			width: 100%;
			display:inline-block;
		} 
	}
</style>
